<template>
  <div class="container">
    <el-container>
      <el-header><Header></Header></el-header>
      <el-container>
        <el-aside v-if="$store.getters.isPC"><Menu></Menu></el-aside>
        <el-main> 
          <router-view :key="getAuthorityRoute" class="main-router-view" />
          <Footer v-if="$store.getters.authorityRoute !== '/parent'"></Footer>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Menu from "./Menu";
import Footer from "./Footer";
import Header from "./Header";
export default {
  components: { Menu, Header,Footer },
  computed: {
   getAuthorityRoute(){
      const path = this.$route.path
      const re = /^(\/[^/]*)/g
      return re.exec(path)[1]
    }
  },
};
</script>

<style lang="scss" scoped>
.container{
  background-color: #ECF0F5;
}
.container, .is-vertical{
  padding: 0;
  margin: 0;
}
.el-header {
  height: auto !important;
  padding: 0;
}
.el-main {
  padding: 0;
  padding: 1.875rem 2.1875rem;
}
.main-router-view {
  flex-grow: 1;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .el-main {
    padding: 0.875rem ;
  }
}
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .el-aside{
    display: none;
  }
}
</style>